import { domain, i18n } from 'arm-common';
import * as layouts from 'arm-core-layouts';
import { InputFile } from 'arm-file-uploader';
import * as agui from 'arm-gui/dist/controls';
import * as React from 'react';
import { connect } from 'react-redux';
import Rest from '../../webapi/Rest';
import DocumentiActions from './DocumentiActions';
import { FileConfBox } from './FileConfBox';

class DocumentTab extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Upload.jsx] ";
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            validation: new Map(),
            showConfirmSalvaDoc: false
        };
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount')
    }

    onFileUpload = (file, name) => {
        let validation = this.props.validationDoc;
        if (validation.has("content")) {
            this.props.deleteErrore("content");
        }
        const f = {
            fileId: name,
            fileName: file.name,
            descrizione: "",
            docId: null,
        };
        this.props.handleChangeDoc("content", f);
    };

    templateUpload = (file, name) => {
        let validation = this.props.validationDoc;
        if (validation.has("template")) {
            this.props.deleteErrore("template");
        }
        const f = {
            fileId: name,
            fileName: file.name,
            descrizione: "",
            docId: null,
        };
        this.props.handleChangeDoc("template", f);
    };

    handleChange(id, value, tipo) {
        let validationDoc = this.props.validationDoc;
        if (validationDoc.has(id)) {
            this.props.deleteErrore(id);
        }

        this.props.handleChangeDoc(id, value, tipo);
    }


    render() {
        const { nuovoDoc, handleChangeDoc, isAlreadyExistingDoc, isInEditMode } = this.props;
        const baseUrl = Rest.restBaseurl;

        return (
            <>
                <agui.Cellify noMargin={false} >
                    <agui.CoolTextInput
                        colWidth={3}
                        id="alias"
                        value={nuovoDoc?.alias}
                        placeholder={i18n('ARM_CORE_PRINT.SHARED.ALIAS', 'Alias')}
                        required={true}
                        hasError={this.props.validationDoc.get("alias")}
                        label={i18n('ARM_CORE_PRINT.SHARED.ALIAS', 'Alias')}
                        onChange={(value) => this.handleChange('alias', value)}
                        // disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                        disabled={isAlreadyExistingDoc ? true : false}
                    />
                    <agui.CoolSelect
                        colWidth={3}
                        id="categoria"
                        // onChange={(value) => handleChangeDoc('categoria', value)}
                        onChange={(value) => this.handleChange('categoria', value)}
                        value={nuovoDoc?.categoria}
                        label={i18n('ARM_CORE_PRINT.CATEGORIA', 'Categoria')}
                        required={true}
                        hasError={this.props.validationDoc.get("categoria")}
                        items={domain('AI_PRINT_CATEGORIA')}
                        valueKey="valCampo"
                        labelKey="desDom"
                        disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                    />
                    <agui.CoolDateInput
                        wrapClassName="dataInizio"
                        colWidth={3}
                        id="dataInizio"
                        value={nuovoDoc?.dataInizio}
                        placeholder={i18n('ARM.CORE.PRINT.DATA.INIZIO', 'Data Inizio')}
                        required={true}
                        hasError={this.props.validationDoc.get("dataInizio")}
                        label={i18n('ARM.CORE.PRINT.DATA.INIZIO', 'Data Inizio')}
                        // onChange={(value) => handleChangeDoc('dataInizio', value, "date")}
                        onChange={(value) => this.handleChange('dataInizio', value, "date")}
                        disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                    />
                    <agui.CoolSelect
                        colWidth={3}
                        id="engine"
                        // onChange={(value) => handleChangeDoc('engine', value)}
                        onChange={(value) => this.handleChange('engine', value)}
                        value={nuovoDoc?.engine}
                        label={i18n('ARM_CORE_PRINT.SHARED.ENGINE', 'Engine')}
                        required={true}
                        hasError={this.props.validationDoc.get("engine")}
                        items={domain('AI_PRINT_ENGINE')}
                        valueKey="valCampo"
                        labelKey="desDom"
                        disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                    />

                    <agui.CoolSelect
                        colWidth={3}
                        id="lingua"
                        onChange={(value) => this.handleChange('lingua', value)}
                        value={nuovoDoc?.lingua}
                        label={i18n('ARM_CORE_PRINT.LINGUA', 'Lingua')}
                        required={true}
                        hasError={this.props.validationDoc.get("lingua")}
                        items={domain("AI_PRINT_LINGUA")}
                        valueKey="valCampo"
                        labelKey="desDom"
                        disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                    />

                </agui.Cellify>
                {/* al momento non gestito */}
                {this.props.nuovoDoc.engine && this.props.nuovoDoc.engine === "PDF_PRINT" && false ?

                    <div className={this.props.validationDoc.get("content") === "" || this.props.validationDoc.get("content") === null || this.props.validationDoc.get("content") === undefined ? "mb-2 input-file-row mt-4" : "mb-2 input-file-row input-template-error mt-4"} colWidth={6}>
                        {(!isAlreadyExistingDoc || (isAlreadyExistingDoc && isInEditMode && !nuovoDoc.content.docId)) &&
                            <>
                                <span className="lab-input-file">{i18n("ARM_CORE_PRINT.SHARED.UPLOAD_DOC", "Seleziona qui il contento")} </span>
                                <InputFile
                                    ref={(r) => this.inputFile = r}
                                    label={i18n("ARM_CORE_PRINT.SHARED.UPLOAD_DOC", 'Upload Contento')}
                                    compact={true}
                                    clearOnUpload={true}
                                    onFileUpload={(f, n) => this.onFileUpload(f, n)}
                                    uploadURL={baseUrl}
                                    id='content'
                                    name='content'
                                    hasError={this.props.validationDoc.get("content")}
                                    disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                                />
                            </>
                        }
                        <div className="files mt-2">
                            {
                                // nuovoDoc.contentId && nuovoDoc.content ?
                                nuovoDoc?.content?.docId || nuovoDoc?.content?.fileId ?
                                    <FileConfBox
                                        file={nuovoDoc.content}
                                        fileIdx={nuovoDoc.contentId}
                                        isInEditMode={isInEditMode ? true : nuovoDoc?.content?.fileId ? true : false}
                                        removeFile={() => this.props.removeFile(null, 'content')}
                                        change={this.change}
                                    />
                                    : null
                            }
                        </div>
                    </div>
                    :
                    null
                }

                {this.props.nuovoDoc.engine && this.props.nuovoDoc.engine === "ASPOSE" || this.props.nuovoDoc.engine && this.props.nuovoDoc.engine === "PDF_PRINT" ?


                    <div className={this.props.validationDoc.get("template") === "" || this.props.validationDoc.get("template") === null || this.props.validationDoc.get("template") === undefined ? "mb-2 input-file-row input-template mt-4" : "mb-2 input-file-row input-template-error mt-4"} colWidth={6}>
                        {(!isAlreadyExistingDoc || (isAlreadyExistingDoc && isInEditMode && !nuovoDoc.template.docId && !nuovoDoc.template.fileId)) &&
                            <>
                                <span className="lab-input-file">{i18n("ARM_CORE_PRINT.SHARED.UPLOAD_TEMPLATE", "Seleziona qui il template")} </span>
                                <InputFile
                                    ref={(r) => this.inputFile = r}
                                    label={i18n("ARM_CORE_PRINT.SHARED.UPLOAD_TEMPLATE", 'Upload Template')}
                                    compact={true}
                                    clearOnUpload={true}
                                    onFileUpload={(f, n) => this.templateUpload(f, n)}
                                    uploadURL={baseUrl}
                                    id='template'
                                    name='template'
                                    className='template'
                                    hasError={this.props.validationDoc.get("template")}
                                    disabled={isAlreadyExistingDoc ? (isInEditMode ? false : true) : false}
                                />
                            </>
                        }

                        <div className="files mt-2">
                            {
                                nuovoDoc?.template?.docId || nuovoDoc?.template?.fileId ?
                                    <FileConfBox scaricaDocument={this.props.scaricaDocument}
                                        label={i18n("ARM_CORE_PRINT.SHARED.TEMPLATE", 'Template')}
                                        disabled={!isAlreadyExistingDoc} file={nuovoDoc.template}
                                        isInEditMode={isInEditMode ? true : nuovoDoc?.template?.fileId ? true : false}
                                        fileIdx={nuovoDoc.template.docId}
                                        removeFile={() => this.props.removeFile(null, 'template')}
                                        change={this.change} />
                                    : null
                            }

                        </div>
                    </div> :
                    null
                }

            </>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleChangeDoc(id, value, tipo) {
            return dispatch(DocumentiActions.handleChangeDoc(id, value, tipo));
        },
        removeFile(fileIdx, name) {
            return dispatch(DocumentiActions.removeFile(fileIdx, name));
        },
        eliminaDoc() {
            return dispatch(DocumentiActions.eliminaDoc());
        },
        setIsAlreadyExistingDoc(isAlreadyExistingDoc) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(isAlreadyExistingDoc));
        },
        resetDoc() {
            return dispatch(DocumentiActions.resetDoc());
        },
        scaricaDocument(id) {
            return dispatch(DocumentiActions.scaricaDocument(id));
        },
        validationDocument(key, value) {
            return dispatch(DocumentiActions.validationDocument(key, value))
        },
        deleteErrore(id) {
            return dispatch(DocumentiActions.deleteErrore(id))
        },

    }

};

function mapStateToProps(state) {
    return {
        listaDoc: state.documentiReducer.listaDoc,
        nuovoDoc: state.documentiReducer.nuovoDoc,
        tabSelected: state.documentiReducer.tabSelected,
        listaDataSource: state.documentiReducer.listaDataSource,
        isAlreadyExistingDoc: state.documentiReducer.isAlreadyExistingDoc,
        isInEditMode: state.documentiReducer.isInEditMode,
        parametersMap: state.documentiReducer.parametersMap,
        validationDoc: state.documentiReducer.validationDoc
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTab);